import {getScrollbarWidth} from "./designUtils";

document.documentElement.style.setProperty("--scrollbar-width", `${getScrollbarWidth()}px`);
